CTA_EVENT_CATEGORY_DEFAULT = 'cta-unknown';

function addCtaClickListener() {
  document.body.addEventListener('click', event => {
    const { target } = event;
    const { parentElement } = target;
    sendGoogleAnalyticsEvent(target) || sendGoogleAnalyticsEvent(parentElement);
  });
}

function sendGoogleAnalyticsEvent(element) {
  const { gaAction, gaCategory, gaLabel } = element.dataset;
  if (gaAction) {
    gtag('event', gaAction, {
      'event_category': gaCategory || this.CTA_EVENT_CATEGORY_DEFAULT,
      'event_label': gaLabel
    });
    return true;
  }
  return false;
}

function replayVideos() {
  const videoElements = document.getElementsByTagName("video");
  for (let i = 0; i < videoElements.length; i++) {
    const video = videoElements[i];
    if (video.autoplay && !video.playing) {
      video.play();
    }
  }
}
function videoListener() {
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      replayVideos();
    }
  });

  const event = 'ontouchstart' in window ? 'touchstart' : 'scroll';
  window.addEventListener(event, replayVideos, { once: true });
}

addCtaClickListener();
videoListener();
